"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabStyles = void 0;
var Colors_1 = require("./Colors");
// If you have any questions about this file, message #tab-dev-shared-widgets
var SpacingUnit = 6;
var SizingUnit = SpacingUnit;
var FontSizes = {
    XXLarge: 24,
    XLarge: 18,
    Large: 13,
    Default: 12,
    Small: 11,
    Tiny: 10
};
var FontColors = {
    PrimaryDark: 'rgba(0, 0, 0, 0.9)',
    Primary: 'rgba(0, 0, 0, 0.8)',
    PrimaryMedium: 'rgba(0, 0, 0, 0.7)',
    PrimaryLight: 'rgba(0, 0, 0, 0.6)',
    Secondary: 'rgba(0, 0, 0, 0.56)',
    Disabled: Colors_1.TextColors.Disabled,
    InvertedPrimary: 'rgb(255, 255, 255)',
    InvertedSecondary: 'rgba(255, 255, 255, 0.96)',
    InvertedDisabled: Colors_1.InvertTextColors.Disabled,
};
var GreyColors = {
    Grey250: 'rgb(250, 250, 250)',
    Grey245: 'rgb(245, 245, 245)',
    Grey235: 'rgb(235, 235, 235)',
    Grey230: 'rgb(230, 230, 230)',
    Grey225: 'rgb(225, 225, 225)',
    Grey212: 'rgb(212, 212, 212)',
    Grey203: 'rgb(203, 203, 203)',
    Grey180: 'rgb(180, 180, 180)',
    Grey180Disabled: 'rgba(180, 180, 180, 0.35)',
    Grey102: 'rgb(102, 102, 102)',
    Grey51: 'rgb(51, 51, 51)',
    Grey51Disabled: 'rgba(51, 51, 51, 0.2)',
};
var SemanticColors = {
    White: 'rgb(255, 255, 255)',
    WhiteTransparent: 'rgba(255, 255, 255, 0.25)',
    WhiteDisabled: 'rgba(255, 255, 255, 0.35)',
    WhiteTransparentLine: 'rgba(255, 255, 255, 0.5)',
    WhiteTransparentLineHover: 'rgba(255, 255, 255, 0.8)',
    Black: 'rgb(0, 0, 0)',
    Transparent: 'rgba(0, 0, 0, 0)',
    ActionLight: 'rgb(235, 143, 80)',
    ActionDark: 'rgb(209, 107, 54)',
    AttentionLight: 'rgb(235, 68, 84)',
    AttentionDark: 'rgb(201, 58, 71)',
    AttentionDarkDisabled: 'rgba(201, 58, 71, 0.35)',
    Continuous: 'rgb(0, 177, 128)',
    ContinuousDark: 'rgb(0, 151, 104)',
    Discrete: 'rgb(73, 150, 178)',
    DiscreteDark: 'rgb(54, 126,156)',
    GoLight: 'rgb(45, 204, 151)',
    GoDark: 'rgb(47, 163, 125)',
    GoDarkDisabled: 'rgba(47, 163, 125, 0.35)',
    Shaded: 'rgba(0, 0, 0, 0.07)',
    ApplicationBlue: 'rgb(34, 38, 54)',
    DesktopBlue: 'rgb(53, 92, 128)',
    ServerBlue: 'rgb(42, 87, 117)',
    OnlineBlue: 'rgb(40, 94, 127)',
    OpaqueGlass: GreyColors.Grey245,
    Focus: 'rgb(11, 92, 171)',
    L1: GreyColors.Grey250,
    L2: GreyColors.Grey245,
    L2_5: GreyColors.Grey235,
    L3: GreyColors.Grey230,
    L4: GreyColors.Grey225,
    L5: GreyColors.Grey212,
    L6: GreyColors.Grey203,
    L7: GreyColors.Grey180,
    L8: GreyColors.Grey102,
    L9: GreyColors.Grey51,
    L9Disabled: GreyColors.Grey51Disabled,
    F1: GreyColors.Grey250,
    F2: GreyColors.Grey245,
    F2_5: GreyColors.Grey235,
    F3: GreyColors.Grey230,
    F4: GreyColors.Grey225,
    F5: GreyColors.Grey212,
    F6: GreyColors.Grey203,
    F7: GreyColors.Grey180,
    F7Disabled: GreyColors.Grey180Disabled,
    F8: GreyColors.Grey102,
    F9: GreyColors.Grey51
};
exports.TabStyles = {
    Colors: SemanticColors,
    Shadow: {
        Elevated: '0 2px 16px 0 rgba(51, 51, 51, 0.15)',
        Standard: '1px 1px 2px 0px rgba(0, 0, 0, 0.15)',
    },
    Spacing: {
        SmallSpace: SpacingUnit / 2,
        DefaultSpace: SpacingUnit,
        MediumSpace: SpacingUnit * 2,
        LargeSpace: SpacingUnit * 3,
        ExtraLargeSpace: SpacingUnit * 4,
    },
    Sizing: {
        BaseUnit: SizingUnit,
        RowHeight: 24,
        ButtonMinWidth: SizingUnit * 15,
        BorderWidth: 1,
        ButtonBorderWidth: 2,
        BorderRadius: 1,
        SelectionBorderWidth: SizingUnit / 2,
        ListRowHeight: 20
    },
    Typography: {
        FontFamily: 'inherit',
        Sizing: FontSizes,
        Color: FontColors
    },
    Opacity: {
        ClearGlass: 0.01,
        Disabled: 0.35,
        OpaqueGlass: 0.33,
    },
};
//# sourceMappingURL=TabStyles.js.map